import React from "react";
import "./Home.css";
import { SubmissionButton } from "../SumbissionButton";
import { Profile } from "../Profile";

export const IndustryCalls = () => {
  const submitButton = {
    title: "Industry Track Paper",
    url: "https://edas.info/N33043",
  };

  const profilesIndustry = [
    {
      title: "Dr",
      firstName: "Hana",
      surname: "Khamfroush",
      university: "University of Kentucky, USA",
      bio: "https://www.engr.uky.edu/directory/khamfroush-hana",
      image: "./images/profiles/Khamfroush.jpg",
      linkedin: "https://www.linkedin.com/in/hana-khamfroush-041aa427/",
      twitter: null,
      email: "khamfroush@uky.edu",
    },
    {
      title: "Dr",
      firstName: "Ahmed",
      surname: "Khalid",
      university: "Dell Technologies, Ireland",
      bio: "https://www.ucc.ie/en/misl/recentmislalumni/akhalid/",
      image: "./images/profiles/Khalid.jpg",
      linkedin:
        "https://www.linkedin.com/in/ahmed-khalid-10834217/?originalSubdomain=ie",
      email: "ahmed.khalid@dell.com",
    },
  ];

  return (
    <div className="page-layout">
      <div className="text-layout">
        <SubmissionButton props={submitButton} className="submit-button" />
        <h2>Call for Industry Track Papers</h2>
        <p>
          SMARTCOMP 2025, the 11th edition of the premier conference on smart
          computing, will be held in Cork, Ireland, June 16-19.
        </p>
        <p>
          In addition to the main research track, the conference invites
          innovative applications and advances in the industrial use of smart
          computing technology. The industry track will provide a forum to
          discuss novel ideas and emerging results, present innovative
          applications and tools, and bring about novel research questions,
          approaches, and directions with an industry focus. The conference
          industry track draws upon many industrial applications such as
          transportation, energy, environmental protection, resource management,
          healthcare, security, banking, entertainment, and social media.
        </p>
        <p>
          An important criterion for papers to be submitted to the Industry
          Track is the clear industrial association, either in the form of an
          extensive evaluation of research results in industrial use cases or
          the active participation of industry representatives as co-authors.
        </p>
        <p>
          Accepted papers will be published as part of a separate section of the
          main conference proceedings that highlights the Industry relevance of
          the submission.
        </p>
        <h3>Topics</h3>
        <p>
          Industry Track Topics include, but are not limited to, the following:
        </p>
        <ul>
          <li>
            Smart Cyber-Physical Environments and Energy / Water / Agriculture/
            Transportation / Healthcare / Banking Infrastructure / Smart
            Communities
          </li>
          <li>Security, Privacy, and Economics in Smart Environments</li>
          <li>Smart and Connected Communities across Cities</li>
          <li>Future Smart Computing Paradigms</li>
          <li>
            Smart Human-centric Environments, Health, Entertainment, and Social
            Activities
          </li>
          <li>
            Artificial Intelligence and Machine Learning for Smart Computing
          </li>
          <li>Middleware for smart systems</li>
          <li>Novel computation paradigms in Smart Computing systems</li>
          <li>Quantum Computing in Smart Systems</li>
        </ul>
        <h3 style={{ marginTop: "30px" }}>Important Dates</h3>
        <p>
          Paper Submission:{" "}
          <span style={{ fontWeight: "bold", textDecoration: "line-through" }}>
            23rd February 2025
          </span>{" "}
          <span
            style={{
              fontWeight: "bold",
              color: "blue",
              textDecoration: "line-through",
            }}
          >
            9th March 2025
          </span>{" "}
          <span style={{ fontWeight: "bold", color: "red" }}>
            16th March 2025 (firm)
          </span>
        </p>
        <p>
          Acceptance Notification:{" "}
          <span style={{ fontWeight: "bold" }}>14th April 2025</span>
        </p>{" "}
        <p>
          Camera Ready (tentative):{" "}
          <span style={{ fontWeight: "bold" }}>10th May 2025</span>
        </p>{" "}
        <p>
          Conference:{" "}
          <span style={{ fontWeight: "bold" }}>16th to 19th June 2025</span>
        </p>{" "}
        <p>All deadlines are Anywhere on Earth.</p>{" "}
        <h3>Submission Guidelines</h3>
        <p>
          Paper submissions must be no longer than 8 pages (the page count limit
          includes the references list) and formatted according to the
          two-column IEEE proceedings template. All submitted papers that
          conform to these guidelines will be subject to peer reviews by
          Technical Program Committee members and other experts in the field.
          All presented papers will be published in the conference proceedings
          and submitted to the IEEEXplore Digital Library.
        </p>
        <p>
          Since the conference will be an entire in-presence event, no virtual
          or remote presentation will be allowed.
        </p>{" "}
        <p style={{ textDecoration: "underline" }}>
          Accepted papers must be presented in person by one of the authors, in
          addition to having an associated full registration. Failure to comply
          with this requirement will result in the exclusion of the paper from
          the final proceedings, the conference program and from the IEEE
          Digital Library. We also strongly advise authors of submitted papers
          to be prepared to apply for their Irish visa as soon as their paper is
          accepted.
        </p>{" "}
        <p>
          <span style={{ fontWeight: "bold" }}>
            The conference applies a single-blind review process.
          </span>
        </p>{" "}
        <SubmissionButton props={submitButton} />
        <p>Paper registration will open on 1 November 2024</p>
        <p>
          One additional page for the camera-ready version can be purchased
          after the paper review and selection.
        </p>
        <hr style={{ marginTop: "20px" }} />
        <h3>Industry Track Co-Chairs</h3>
        <div>
          {profilesIndustry.map(function (data) {
            return <Profile props={data} />;
          })}
        </div>
        <h3>Contact Information</h3>
        <p>
          For any questions about the conference, please contact the TPC
          Co-Chairs and General Chairs at:{" "}
          <a href="mailto: smartcomp2025@iit.cnr.it">
            smartcomp2025@iit.cnr.it
          </a>
        </p>
      </div>
    </div>
  );
};
